import React from 'react'
import { withRouter, RouteComponentProps } from 'react-router'
import { Box } from '@deal/components'
import { withIdentity, WithIdentityProps } from '#src/containers/Identity'
import { LoggedInCart, GuestCart } from '#src/components/ShoppingCart'
import FlyoutMenu, { FlyoutMenuProps } from '#src/components/FlyoutMenu'
import styles from './styles.css'

interface CartProps extends RouteComponentProps<{}>, Partial<FlyoutMenuProps> {}

interface CartState {
  // To prevent inconsistencies with SSR (the location.hash is unavailable on the server),
  //   we only open the cart after it has been mounted.
  mounted: boolean
}

class Cart extends React.Component<CartProps & WithIdentityProps, CartState> {
  public state: CartState = {
    mounted: false
  }

  public componentDidMount() {
    this.setState({
      mounted: true
    })
  }

  public render() {
    const {
      location,
      history,
      match,
      staticContext,
      myself,
      refetchIdentity,
      userId,
      sessionId,
      ...rest
    } = this.props

    return (
      <FlyoutMenu
        from="right"
        open={this.state.mounted && location.hash === '#cart'}
        onClose={() => history.replace({ ...location, hash: undefined })}
        title="Your cart"
        pageKey="cart-view"
        data-testid="cart-overlay"
        {...rest}
      >
        <Box.Item grow={1} className={styles.cartContainer}>
          {myself ? <LoggedInCart /> : <GuestCart />}
        </Box.Item>
      </FlyoutMenu>
    )
  }
}
export default withRouter(withIdentity(Cart))
